import { render, staticRenderFns } from "./UserTreeview.vue?vue&type=template&id=6f737a55&"
import script from "./UserTreeview.vue?vue&type=script&lang=ts&"
export * from "./UserTreeview.vue?vue&type=script&lang=ts&"
import style0 from "./UserTreeview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VTreeview})
